import type { WorkingConditionLocale } from "@/locales/fr/working-condition";

import {
  ESiteWorkingConditionAcquisitionStatus,
  ESiteWorkingConditionModulationStatus,
} from "@/types/backoffice/dto/site/working-condition/site-working-condition-dto.ts";

const workingConditionLocale: WorkingConditionLocale = {
  workingCondition: {
    acquisition: "Acquisition",
    modulation: "Modulations",
    deviceDetails: {
      name: "Name (MyVoltalis): {name}",
      modulatorName: "Name (Modulator): {name}",
      linkName: "Name (Link): {name}",
      techName: "Installation Name (Tech): {name}",
      serial: "Serial Number: {serial}",
      maxPower: "Max Power: {n} watts",
      type: "Device type: {type}",
      roomType: "Room type: {type}",
      appliance: "Appliance: {appliance}",
      power: "Max power: {power}",
      update: "Update",
      modulator: "Modulator id: {modulatorId}",
      linkCsId: "Link Cs Id: {linkCsId}",
    },
    level: {
      low: "Low",
      normal: "Normal",
      high: "High",
      none: "None",
    },
    acquisitionStatus: {
      [ESiteWorkingConditionAcquisitionStatus.UNKNOWN]: "Unknown",
      [ESiteWorkingConditionAcquisitionStatus.BAD]: "Bad",
      [ESiteWorkingConditionAcquisitionStatus.MEDIUM]: "Medium",
      [ESiteWorkingConditionAcquisitionStatus.GOOD]: "Good",
    },
    modulationStatus: {
      [ESiteWorkingConditionModulationStatus.UNKNOWN]: "Unknown",
      [ESiteWorkingConditionModulationStatus.NONE]: "None",
      [ESiteWorkingConditionModulationStatus.NOT_TESTED]: "Not Tested",
      [ESiteWorkingConditionModulationStatus.KO_DETECTED]: "Ko Detected",
      [ESiteWorkingConditionModulationStatus.SUCCESS]: "Success",
    },
    modulationTableHeaders: {
      name: "Name (MyVoltalis)",
      status: "Status",
      number: "Number",
      level: "Level",
      lastComm: "Last Communication",
    },
    acquisitionModulatorTableHeaders: {
      name: "Name (MyVoltalis)",
      momboxSerialNumber: "Mombox Serial Number",
      momboxPresentOnSite: "Mombox on site?",
      momboxSiteId: "Mombox Site ID",
      acqRate: "Acquisition Rate",
      lastComm: "Last Communication",
      ping: "Ping",
    },
    acquisitionMomboxTableHeaders: {
      siteId: "Site ID",
      name: "Name",
      hwId: "HW ID",
      csId: "CS ID",
      serialNumber: "Serial Number",
      operator: "Operator",
      presentOnSite: "On site?",
      lastSync: "Last Sync",
      softwareVersion: "Software Version",
    },
    acquisitionSensorsTableHeaders: {
      name: "Room Name",
      serial: "Serial Number",
      installationDate: "Installation Date",
      lastPoint: "Last Point Date",
    },
    installationTests: {
      headers: {
        testId: "Test Id",
        date: "Date",
        result: "Result",
        details: "Details",
      },
      status: {
        OK: "Ok",
        NOK: "Nok",
        UNKNOWN: "Unknown",
      },
      loading: "Loading installation tests",
      empty: "No installation test found",
      error: "Unable to load installation tests",
      partial: "Some installation tests could not be loaded",
      retry: "Retry",
      expand: "Show installation tests for {appliance} on modulator {modulator}",
      collapse: "Hide installation tests for {appliance} on modulator {modulator}",
    },
  },
};

export default workingConditionLocale;
